module.exports = __webpack_public_path__ + "BradescoSans-Bold-CISt2qSU.23feadea48bccf299e3a.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/bradesco/BradescoSans-Bold-CISt2qSU.woff2
// module id = ../../../../../src/assets/fonts/bradesco/BradescoSans-Bold-CISt2qSU.woff2
// module chunks = styles